<!doctype html>
<html lang="en-US" dir="ltr" xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">
<head>
  <title>Google Assistant Class Action Settlement</title>
  <!--[if !mso]><!-->
  <meta http-equiv="X-UA-Compatible" content="IE=edge">
  <!--<![endif]-->
  <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <style type="text/css">
    #outlook a {
      padding: 0;
    }

    body {
      margin: 0;
      padding: 0;
      -webkit-text-size-adjust: 100%;
      -ms-text-size-adjust: 100%;
    }

    table, td {
      border-collapse: collapse;
      mso-table-lspace: 0pt;
      mso-table-rspace: 0pt;
    }

    img {
      border: 0;
      height: auto;
      line-height: 100%;
      outline: none;
      text-decoration: none;
      -ms-interpolation-mode: bicubic;
    }

    p {
      display: block;
      margin: 13px 0;
    }
  </style>
  <!--[if mso]>
  <noscript>
  <xml>
  <o:OfficeDocumentSettings>
    <o:AllowPNG/>
    <o:PixelsPerInch>96</o:PixelsPerInch>
  </o:OfficeDocumentSettings>
  </xml>
  </noscript>
  <![endif]-->
  <!--[if lte mso 11]>
  <style type="text/css">
    .mj-outlook-group-fix { width:100% !important; }
  </style>
  <![endif]-->


  <style type="text/css">
    @media only screen and (min-width:480px) {
      .mj-column-per-100 {
        width: 100% !important;
        max-width: 100%;
      }

      .mj-column-per-75 {
        width: 75% !important;
        max-width: 75%;
      }

      .mj-column-per-25 {
        width: 25% !important;
        max-width: 25%;
      }
    }
  </style>
  <style media="screen and (min-width:480px)">
    .moz-text-html .mj-column-per-100 {
      width: 100% !important;
      max-width: 100%;
    }

    .moz-text-html .mj-column-per-75 {
      width: 75% !important;
      max-width: 75%;
    }

    .moz-text-html .mj-column-per-25 {
      width: 25% !important;
      max-width: 25%;
    }
  </style>
  <style type="text/css">
    [owa] .mj-column-per-100 {
      width: 100% !important;
      max-width: 100%;
    }

    [owa] .mj-column-per-75 {
      width: 75% !important;
      max-width: 75%;
    }

    [owa] .mj-column-per-25 {
      width: 25% !important;
      max-width: 25%;
    }
  </style>

  <style type="text/css">
  </style>
  <style type="text/css">
  </style>

</head>
<body style="word-spacing:normal;background-color:transparent;">


  <div style="background-color:transparent;" role="main" lang="en-US" dir="ltr">


    <!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" class="" role="presentation" style="width:600px;" width="600" bgcolor="#ffffff" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->


    <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;">

      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding:0px 0px 0px 0px;text-align:center;">
              <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:bottom;width:600px;" ><![endif]-->

              <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:bottom;width:100%;">

                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:bottom;" width="100%">
                  <tbody>

                    <tr>
                      <td align="left" style="font-size:0px;padding:0px 25px 0px 25px;padding-top:0px;padding-bottom:0px;word-break:break-word;">

                        <div style="font-family:Verdana, Helvetica, Arial, sans-serif;font-size:14px;letter-spacing:normal;line-height:1;text-align:left;color:#000000;"><p class="text-build-content" style="text-align: center; margin: 10px 0; margin-top: 10px; margin-bottom: 10px;"><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:11px">To read this email in a browser </span><a class="link-build-content" style="color:inherit;text-decoration:none;" target="_blank" href="https://www.email.googleassistantprivacylitigation.com/reminder-en"><span style="color:#1869d4;font-family:Verdana, Arial, sans-serif;font-size:11px">click here</span></a><br><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:11px">Para leer este correo electrónico en un navegador, </span><a class="link-build-content" style="color:inherit;text-decoration:none;" target="_blank" href="https://www.email.googleassistantprivacylitigation.com/reminder-sp"><span style="color:#1869d4;font-family:Verdana, Arial, sans-serif;font-size:11px">haga clic aquí</span></a></p></div>

                      </td>
                    </tr>

                  </tbody>
                </table>

              </div>

              <!--[if mso | IE]></td></tr></table><![endif]-->
            </td>
          </tr>
        </tbody>
      </table>

    </div>


    <!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" class="" role="presentation" style="width:600px;" width="600" bgcolor="#ffffff" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->


    <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;">

      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding:0px 0px 0px 0px;text-align:center;">
              <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:bottom;width:450px;" ><![endif]-->

              <div class="mj-column-per-75 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:bottom;width:100%;">

                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:bottom;" width="100%">
                  <tbody>

                    <tr>
                      <td align="left" style="font-size:0px;padding:0px 0px 0px 0px;padding-top:0px;padding-bottom:0px;word-break:break-word;">

                        <div style="font-family:Verdana, Helvetica, Arial, sans-serif;font-size:14px;letter-spacing:normal;line-height:1;text-align:left;color:#000000;"><p class="text-build-content" style="text-align: right; margin: 10px 0; margin-top: 10px; margin-bottom: 10px;"><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px">Share This Settlement</span></p></div>

                      </td>
                    </tr>

                  </tbody>
                </table>

              </div>

              <!--[if mso | IE]></td><td class="" style="vertical-align:bottom;width:150px;" ><![endif]-->

              <div class="mj-column-per-25 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:bottom;width:100%;">

                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:bottom;" width="100%">
                  <tbody>

                    <tr>
                      <td align="right" style="font-size:0px;padding:0px 0px 5px 0px;word-break:break-word;">


                        <!--[if mso | IE]><table align="right" border="0" cellpadding="0" cellspacing="0" role="presentation" ><tr><td><![endif]-->
                        <table align="right" border="0" cellpadding="0" cellspacing="0" role="presentation" style="float:none;display:inline-table;">
                          <tbody>

                            <tr>

                              <td aria-hidden="true" style="padding:4px;vertical-align:middle;">
                                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#3B5998;border-radius:3px;width:25px;">
                                  <tbody>
                                    <tr>
                                      <td style="font-size:0;height:25px;vertical-align:middle;width:25px;">
                                        <a href="http://www.facebook.com/share.php?u=https%3A%2F%2Fwww.googleassistantprivacylitigation.com" target="_blank">
                                          <img alt="Share this Settlement on Facebook" height="25" src="https://static.mailjet.com/ico-social/facebook.png" style="border-radius:3px;display:block;" width="25" />
                                        </a>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>



                            </tr>

                          </tbody>
                        </table>
                        <!--[if mso | IE]></td><td><![endif]-->
                        <table align="right" border="0" cellpadding="0" cellspacing="0" role="presentation" style="float:none;display:inline-table;">
                          <tbody>

                            <tr>

                              <td aria-hidden="true" style="padding:4px;vertical-align:middle;">
                                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#0077B5;border-radius:3px;width:25px;">
                                  <tbody>
                                    <tr>
                                      <td style="font-size:0;height:25px;vertical-align:middle;width:25px;">
                                        <a href="https://www.linkedin.com/sharing/share-offsite/?url=https://www.googleassistantprivacylitigation.com" target="_blank">
                                          <img alt="Share this Settlement on LinkedIn" height="25" src="https://static.mailjet.com/ico-social/linkedin.png" style="border-radius:3px;display:block;" width="25" />
                                        </a>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>



                            </tr>

                          </tbody>
                        </table>
                        <!--[if mso | IE]></td><td><![endif]-->
                        <table align="right" border="0" cellpadding="0" cellspacing="0" role="presentation" style="float:none;display:inline-table;">
                          <tbody>

                            <tr>

                              <td aria-hidden="true" style="padding:4px;vertical-align:middle;">
                                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#0F141A;border-radius:3px;width:25px;">
                                  <tbody>
                                    <tr>
                                      <td style="font-size:0;height:25px;vertical-align:middle;width:25px;">
                                        <a href="https://twitter.com/intent/tweet?text=Did%20you%20buy%20a%20Google-Made%20Device%20that%20uses%20the%20Google%20Assistant%3F%20Or%20did%20the%20Google%20Assistant%20record%20your%20private%20conversations%3F%20You%20could%20be%20eligible%20for%20money%20from%20a%20%2468%20million%20settlement.%20Learn%20more%20at%20www.GoogleAssistantPrivacyLitigation.com." target="_blank">
                                          <img alt="Share this Settlement on X (Twitter)" height="25" src="https://static.mailjet.com/ico-social/twitter-x.png" style="border-radius:3px;display:block;" width="25" />
                                        </a>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>



                            </tr>

                          </tbody>
                        </table>
                        <!--[if mso | IE]></td></tr></table><![endif]-->


                      </td>
                    </tr>

                  </tbody>
                </table>

              </div>

              <!--[if mso | IE]></td></tr></table><![endif]-->
            </td>
          </tr>
        </tbody>
      </table>

    </div>


    <!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" class="" role="presentation" style="width:600px;" width="600" bgcolor="#1869d4" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->


    <div style="background:#1869d4;background-color:#1869d4;margin:0px auto;max-width:600px;">

      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#1869d4;background-color:#1869d4;width:100%;">
        <tbody>
          <tr>
            <td style="border:1px solid #1869d4;direction:ltr;font-size:0px;padding:0px 0px 0px 0px;text-align:center;">
              <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:598px;" ><![endif]-->

              <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">

                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>

                    <tr>
                      <td align="left" style="font-size:0px;padding:10px 25px 10px 25px;padding-top:10px;padding-bottom:10px;word-break:break-word;">

                        <div style="font-family:Verdana, Helvetica, Arial, sans-serif;font-size:20px;letter-spacing:normal;line-height:1;text-align:left;color:#55575d;"><p class="text-build-content" style="margin: 10px 0; margin-top: 10px;"><span style="color:#ffffff;font-family:Verdana, Arial, sans-serif;font-size:24px"><b>REMINDER</b></span></p><p class="text-build-content" style="margin: 10px 0;"><span style="color:#ffffff;font-family:Verdana, Arial, sans-serif;font-size:20px"><b>Google Assistant Privacy Litigation Settlement</b></span></p><p class="text-build-content" style="margin: 10px 0; margin-bottom: 10px;"><span style="color:#ffffff;font-family:Verdana, Arial, sans-serif;font-size:16px">If, between May 18, 2016 and March 19, 2026, (a) you purchased a Google-Made Device that uses Google Assistant, or (b) your communications were recorded or otherwise obtained by Google Assistant as a result of a False Accept or disclosed to a third-party review vendor, you could be entitled to payment from a class action settlement.</span></p></div>

                      </td>
                    </tr>

                  </tbody>
                </table>

              </div>

              <!--[if mso | IE]></td></tr></table><![endif]-->
            </td>
          </tr>
        </tbody>
      </table>

    </div>


    <!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" class="" role="presentation" style="width:600px;" width="600" bgcolor="#1869d4" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->


    <div style="background:#1869d4;background-color:#1869d4;margin:0px auto;max-width:600px;">

      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#1869d4;background-color:#1869d4;width:100%;">
        <tbody>
          <tr>
            <td style="border:1px solid #1869d4;direction:ltr;font-size:0px;padding:0px 0px 0px 0px;text-align:center;">
              <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:middle;width:598px;" ><![endif]-->

              <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">

                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:middle;" width="100%">
                  <tbody>

                    <tr>
                      <td align="right" vertical-align="middle" style="font-size:0px;padding:10px 25px;word-break:break-word;">

                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:separate;line-height:100%;">
                          <tbody>
                            <tr>
                              <td align="center" bgcolor="#cbe6f6" role="presentation" style="border:none;border-radius:50px;cursor:auto;mso-padding-alt:10px 25px 10px 25px;background:#cbe6f6;" valign="middle">
                                <a href="https://www.GoogleAssistantPrivacyLitigation.com/login" style="display:inline-block;background:#cbe6f6;color:#1869d4;font-family:Verdana, Helvetica, Arial, sans-serif;font-size:14px;font-weight:normal;line-height:120%;margin:0;text-decoration:none;text-transform:none;padding:10px 25px 10px 25px;mso-padding-alt:0px;border-radius:50px;" target="_blank">
                                  <span style="background-color:transparent;color:#1869d4;font-family:Verdana, Helvetica, Arial, sans-serif;font-size:14px;"><strong>FILE A CLAIM NOW</strong></span>
                                </a>
                              </td>
                            </tr>
                          </tbody>
                        </table>

                      </td>
                    </tr>

                  </tbody>
                </table>

              </div>

              <!--[if mso | IE]></td></tr></table><![endif]-->
            </td>
          </tr>
        </tbody>
      </table>

    </div>


    <!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" class="" role="presentation" style="width:600px;" width="600" bgcolor="#1869d4" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->


    <div style="background:#1869d4;background-color:#1869d4;margin:0px auto;max-width:600px;">

      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#1869d4;background-color:#1869d4;width:100%;">
        <tbody>
          <tr>
            <td style="border:1px solid #1869d4;direction:ltr;font-size:0px;padding:0px 0px 0px 0px;text-align:center;">
              <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:598px;" ><![endif]-->

              <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">

                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>

                    <tr>
                      <td align="left" style="font-size:0px;padding:5px 25px 0px 25px;padding-top:5px;padding-bottom:0px;word-break:break-word;">

                        <div style="font-family:Verdana, Helvetica, Arial, sans-serif;font-size:13px;letter-spacing:normal;line-height:1;text-align:left;color:#55575d;"><p class="text-build-content" style="line-height: 20px; margin: 10px 0; margin-top: 10px; margin-bottom: 10px;"><span style="color:#ffffff;font-family:Verdana, Arial, sans-serif;font-size:11px">A COURT DIRECTED THIS NOTICE</span></p></div>

                      </td>
                    </tr>

                  </tbody>
                </table>

              </div>

              <!--[if mso | IE]></td></tr></table><![endif]-->
            </td>
          </tr>
        </tbody>
      </table>

    </div>


    <!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" class="" role="presentation" style="width:600px;" width="600" bgcolor="#ffffff" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->


    <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;">

      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding:20px 0;padding-bottom:0px;padding-top:0px;text-align:center;">
              <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" ><![endif]-->

              <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">

                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>

                    <tr>
                      <td align="left" style="font-size:0px;padding:5px 25px 5px 25px;padding-top:5px;padding-bottom:5px;word-break:break-word;">

                        <div style="font-family:Verdana, Helvetica, Arial, sans-serif;font-size:13px;letter-spacing:normal;line-height:1;text-align:left;color:#55575d;"><p class="text-build-content" style="line-height: 20px; margin: 10px 0; margin-top: 10px; margin-bottom: 10px;"><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px">We previously sent you an email because records show you may be eligible for a payment from a Settlement with Defendants Google LLC and Alphabet Inc. (“Google”).</span></p></div>

                      </td>
                    </tr>

                  </tbody>
                </table>

              </div>

              <!--[if mso | IE]></td></tr></table><![endif]-->
            </td>
          </tr>
        </tbody>
      </table>

    </div>


    <!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" class="" role="presentation" style="width:600px;" width="600" bgcolor="#ffffff" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->


    <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;">

      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding:0px 0px 0px 0px;padding-bottom:0px;padding-top:0px;text-align:center;">
              <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:middle;width:600px;" ><![endif]-->

              <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">

                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:middle;" width="100%">
                  <tbody>

                    <tr>
                      <td align="left" style="background:transparent;font-size:0px;padding:5px 25px 5px 25px;padding-top:5px;padding-bottom:5px;word-break:break-word;">

                        <div style="font-family:Verdana, Helvetica, Arial, sans-serif;font-size:13px;letter-spacing:normal;line-height:1;text-align:left;color:#55575d;"><p class="text-build-content" style="line-height: 20px; text-align: center; margin: 10px 0; margin-top: 10px; margin-bottom: 10px;"><span style="color:#1869d4;font-family:Verdana, Arial, sans-serif;font-size:16px"><b>To get money from this Settlement,</b></span><br><span style="color:#1869d4;font-family:Verdana, Arial, sans-serif;font-size:16px"><b>you must File a Claim.</b></span></p></div>

                      </td>
                    </tr>

                    <tr>
                      <td align="center" vertical-align="middle" style="background:transparent;font-size:0px;padding:0px 25px 10px 25px;word-break:break-word;">

                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:separate;line-height:100%;">
                          <tbody>
                            <tr>
                              <td align="center" bgcolor="#cbe6f6" role="presentation" style="border:none;border-radius:50px;cursor:auto;mso-padding-alt:10px 15px 10px 15px;background:#cbe6f6;" valign="middle">
                                <a href="https://www.GoogleAssistantPrivacyLitigation.com/login" style="display:inline-block;background:#cbe6f6;color:#1869d4;font-family:Verdana, Helvetica, Arial, sans-serif;font-size:14px;font-weight:normal;line-height:120%;margin:0;text-decoration:none;text-transform:none;padding:10px 15px 10px 15px;mso-padding-alt:0px;border-radius:50px;" target="_blank">
                                  <span style="background-color:transparent;color:#1869d4;font-family:Verdana, Arial, sans-serif;font-size:14px;"><strong>FILE A CLAIM NOW</strong></span>
                                </a>
                              </td>
                            </tr>
                          </tbody>
                        </table>

                      </td>
                    </tr>

                  </tbody>
                </table>

              </div>

              <!--[if mso | IE]></td></tr></table><![endif]-->
            </td>
          </tr>
        </tbody>
      </table>

    </div>


    <!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" class="" role="presentation" style="width:600px;" width="600" bgcolor="#ffffff" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->


    <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;">

      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding:0px 0px 0px 0px;padding-bottom:0px;padding-top:0px;text-align:center;">
              <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:middle;width:600px;" ><![endif]-->

              <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">

                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:middle;" width="100%">
                  <tbody>

                    <tr>
                      <td align="left" style="background:transparent;font-size:0px;padding:5px 25px 5px 25px;padding-top:5px;padding-bottom:5px;word-break:break-word;">

                        <div style="font-family:Verdana, Helvetica, Arial, sans-serif;font-size:13px;letter-spacing:normal;line-height:1;text-align:left;color:#55575d;"><p class="text-build-content" style="line-height: 20px; text-align: center; margin: 10px 0;; margin-top: 10px; margin-bottom: 10px"><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px">If you already filed your Claim, you do not need to take any action.</span></p></div>

                      </td>
                    </tr>

                  </tbody>
                </table>

              </div>

              <!--[if mso | IE]></td></tr></table><![endif]-->
            </td>
          </tr>
        </tbody>
      </table>

    </div>


    <!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" class="" role="presentation" style="width:600px;" width="600" bgcolor="#def3ff" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->


    <div style="background:#def3ff;background-color:#def3ff;margin:0px auto;max-width:600px;">

      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#def3ff;background-color:#def3ff;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding:20px 0;padding-bottom:0px;padding-top:0px;text-align:center;">
              <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" ><![endif]-->

              <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">

                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>

                    <tr>
                      <td align="left" style="background:transparent;font-size:0px;padding:5px 25px 5px 25px;padding-top:5px;padding-bottom:5px;word-break:break-word;">

                        <div style="font-family:Verdana, Helvetica, Arial, sans-serif;font-size:13px;letter-spacing:normal;line-height:1;text-align:left;color:#55575d;">
                          <p class="text-build-content" style="line-height: 20px; text-align: center; margin: 10px 0; margin-top: 10px;">
                            <span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:16px">
                              The deadline to file a Claim is <b>August 27, 2026</b>.
                            </span>
                          </p><p class="text-build-content" style="line-height: 20px; text-align: center; margin: 10px 0;">
                            <span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:16px">Go to </span><a class="link-build-content" style="color:inherit;text-decoration:none;" target="_blank" href="https://www.GoogleAssistantPrivacyLitigation.com"><span style="color:#1869d4;font-family:Verdana, Arial, sans-serif;font-size:16px"><b>www.GoogleAssistantPrivacyLitigation.com</b></span></a><br><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:16px">
                              <b>to file a Claim online</b>.
                            </span>
                          </p><p class="text-build-content" style="line-height: 20px; text-align: center; margin: 10px 0; margin-bottom: 10px;"><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px">You can also file a Claim by mail.</span></p>
                        </div>

                      </td>
                    </tr>

                  </tbody>
                </table>

              </div>

              <!--[if mso | IE]></td></tr></table><![endif]-->
            </td>
          </tr>
        </tbody>
      </table>

    </div>


    <!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" class="" role="presentation" style="width:600px;" width="600" bgcolor="#ffffff" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->


    <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;">

      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding:20px 0;padding-bottom:0px;padding-top:0px;text-align:center;">
              <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" ><![endif]-->

              <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">

                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>

                    <tr>
                      <td align="left" style="background:transparent;font-size:0px;padding:5px 25px 5px 25px;padding-top:5px;padding-bottom:5px;word-break:break-word;">

                        <div style="font-family:Verdana, Helvetica, Arial, sans-serif;font-size:13px;letter-spacing:normal;line-height:1;text-align:left;color:#55575d;"><p class="text-build-content" style="line-height: 20px; text-align: center; margin: 10px 0; margin-top: 10px; margin-bottom: 10px;"><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px">For more information or to file a claim:</span><br><a class="link-build-content" style="color:inherit;text-decoration:none;" target="_blank" href="https://GoogleAssistantPrivacyLitigation.com"><span style="color:#1869d4;font-family:Verdana, Arial, sans-serif;font-size:14px"><b>www.GoogleAssistantPrivacyLitigation.com</b></span></a><br><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:14px"><b>1-877-411-4704</b></span></p></div>

                      </td>
                    </tr>

                  </tbody>
                </table>

              </div>

              <!--[if mso | IE]></td></tr></table><![endif]-->
            </td>
          </tr>
        </tbody>
      </table>

    </div>


    <!--[if mso | IE]></td></tr></table><![endif]-->


  </div>

</body>
</html>
